// Currently this config returns values necessary for the application to run.

import { StagingAccount } from '../enums/enums'

const defaultApiVersion = 1

const getEnvVar = (key: string): string => {
  const value = process.env[key]

  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`Environment variable ${key} is missing or invalid`)
  }

  return value
}

const loadEnvironmentVariables = (): { apiUrl: string, userPoolId: string, clientId: string, courseFilesUrl: string } => {
  return {
    apiUrl: getEnvVar('REACT_APP_API_URL'),
    userPoolId: getEnvVar('REACT_APP_USER_POOL_ID'),
    clientId: getEnvVar('REACT_APP_CLIENT_ID'),
    courseFilesUrl: getEnvVar('REACT_APP_COURSE_FILES_URL')
  }
}

// SSO Configuration Interface
export interface SSOConfig {
  authority: string
  clientId: string
  redirectUri: string
  scopes: string[]
  responseType: string
}

// SSO Configuration getter
const getSSOConfig = (): SSOConfig => {
  const baseUrl = window.location.origin
  return {
    authority: 'https://dev-78829499.okta.com/oauth2/default',
    clientId: '0oapjq3uymzq79ArT5d7',
    redirectUri: `${baseUrl}/auth/sso/callback`,
    scopes: ['email', 'openid', 'profile'],
    responseType: 'code'
  }
}

export enum Environment {
  DEVELOPMENT = 'development',
  STAGE = 'stage',
  PRODUCTION = 'production',
}

const getAccountSlug = (): string => {
  const hostname = window.location.hostname

  if (hostname === 'localhost') {
    return StagingAccount.StudioApp
  }

  return hostname.split('.')[0]
}

const getEnvironment = (): Environment => {
  const hostname = window.location.hostname

  if (hostname === 'localhost') {
    return Environment.DEVELOPMENT
  }

  if ((Object.values(StagingAccount) as string[]).includes(getAccountSlug())) {
    return Environment.STAGE
  }

  return Environment.PRODUCTION
}

const config = {
  baseUrl: process.env.REACT_APP_API_URL ?? 'https://studio-api.dopa.ge/api/', // URL used to connect to backend app that hosts APIs.  Refer to .env.example for detail on how this is et.
  apiVersion: defaultApiVersion,
  getAccountSlug,
  loadEnvironmentVariables,
  getSSOConfig,
  environment: getEnvironment()
}

export default config
